import { render } from "./InvestasiData.vue?vue&type=template&id=634c5d7e"
import script from "./InvestasiData.vue?vue&type=script&lang=js"
export * from "./InvestasiData.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__